import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FavoriteUser } from '@/hooks/use-favorite-users';
import { useFollowFeedStories } from '@/hooks/use-follow-feed-stories';
import FavoriteUserCard from './FavoriteUserCard';
import FollowFeedStoryViewer from './FollowFeedStoryViewer';

interface FavoriteUsersGridProps {
  favorites: FavoriteUser[];
}

const FavoriteUsersGrid = ({ favorites }: FavoriteUsersGridProps) => {
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const { data: userStories = [] } = useFollowFeedStories();

  // Create array of 20 slots
  const slots = Array.from({ length: 20 }, (_, index) => {
    const position = index + 1;
    return favorites.find(fav => fav.position === position) || null;
  });

  // Get unread counts for each user
  const getUnreadCount = (userId: string) => {
    const userStory = userStories.find(story => story.user_id === userId);
    return userStory?.unread_count || 0;
  };

  const handleUserClick = (favorite: FavoriteUser) => {
    setSelectedUserId(favorite.favorite_user_id);
  };

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {slots.map((favorite, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.02, duration: 0.2 }}
            className="aspect-square"
          >
            <FavoriteUserCard
              favorite={favorite}
              position={index + 1}
              onClick={favorite ? () => handleUserClick(favorite) : undefined}
              unreadCount={favorite ? getUnreadCount(favorite.favorite_user_id) : 0}
            />
          </motion.div>
        ))}
      </div>

      {/* Story Viewer */}
      {selectedUserId && (
        <FollowFeedStoryViewer
          initialUserId={selectedUserId}
          onClose={() => setSelectedUserId(null)}
        />
      )}
    </>
  );
};

export default FavoriteUsersGrid;